<div class="tenant-users">
  @if (!isGlobal) {
    <a href="javascript:void(0)" class="back-link" (click)="goBack()">
      <i class="bi bi-chevron-left"></i> Back to Overview
    </a>
  }

  <div class="d-flex justify-content-between align-items-start mb-3">
    <div>
      <h2 class="page-title">Users</h2>
      <p class="page-subtitle">Manage users and their access</p>
    </div>
    <button type="button" class="btn add-user-btn" (click)="openAdd()">
      <i class="bi bi-plus-lg"></i> Add User
    </button>
  </div>

  <div class="search-box mb-3">
    <i class="bi bi-search"></i>
    <input
      type="text"
      placeholder="Search users..."
      [value]="searchTerm"
      (input)="onSearch($any($event.target).value)"
    />
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loader />
    </div>
  } @else {
    <app-table
      [columns]="columns"
      [data]="rows"
      [actions]="actions"
      [showPagination]="true"
      [currentPage]="page"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      (edit)="onEdit($event)"
      (changePassword)="onChangePassword($event)"
      (delete)="onDelete($event)"
      (columnAction)="onColumnAction($event)"
      (pageChange)="onPageChange($event)"
    />
  }

  @if (modalOpen) {
    <app-tenant-users-modal
      [mode]="modalMode"
      [tenantUid]="tenantUid"
      [user]="selectedUser"
      (closed)="onModalClosed()"
      (saved)="onModalSaved()"
    />
  }

  @if (manageServicesOpen) {
    <app-manage-user-services-modal
      [tenantUid]="tenantUid"
      [user]="manageServicesUser"
      (closed)="onManageServicesClosed()"
      (saved)="onManageServicesSaved()"
    />
  }
</div>
